import React from "react";
import women from "../images/all-women.png";
import vid from "../images/hero-vid.jpg";

const Hero = () => {
  return (
    <div>
      <div className="hero md:hidden">
        <div className="hero-grunge h-[700px] flex justify-end">
          <div className="h-full">
            <img src={women} alt="" className="h-full" />
          </div>
        </div>
        <div className="h-[200px] w-full bg-tertiary relative">
          <div className="bg-secondary text-white w-2/6 absolute bottom-0 left-20 px-14 py-20 space-y-6">
            <div className="pb-6 border-b-2 border-white">
              <h1 className="text-6xl">
                This is an ode to the women among us.
              </h1>
            </div>
            <div>
              <p className="text-xl leading-relaxed">
                Those who walked before us and those to come. Those who wore red
                clay masks and rested their heads on bended knees. Those who
                washed the cowry bead and swung the snuff cup.Those who weaved
                the baskets and wrapped the cloth. Those who fought for peace
                and danced to the drum.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center bg-tertiary text-white">
          <div className="w-3/5">
            <img src={vid} alt="" className="w-full" />
          </div>
          <div className="flex flex-1 items-center justify-center">
            <div className="w-3/5 space-y-6 ">
              <h1>OUR GOAL</h1>
              <p>
                Inspired by the lives of historical women between the 17th and
                19th centuries, we create a portal into the communities they
                led, the items they held dearly, and the spaces they impacted.
                Our stories depict women from all the 10 provinces of Zambia in
                celebration and honour.
              </p>
              <button className="bg-white text-secondary px-10 py-6">
                READ MORE
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-md text-white md-min:hidden">
        <div className="flex flex-col items-center bg-secondary p-10 text-center">
          <h1 className="text-4xl">An ode to the women among us</h1>
          <div className="h-6 mb-6 w-4/5 border-b-2 border-white"></div>
          <p className="">
            Those who walked before us and those to come. Those who wore red
            clay masks and rested their heads on bended knees. Those who washed
            the cowry bead and swung the snuff cup.Those who weaved the baskets
            and wrapped the cloth. Those who fought for peace and danced to the
            drum.
          </p>
        </div>
        <div className="hero-grunge h-max flex justify-center">
          <div className="h-full">
            <img src={women} alt="" className="w-full" />
          </div>
        </div>
        <div className="flex flex-col items-center bg-tertiary px-6 py-10 space-y-10">
          <div className="w-full">
            <img src={vid} alt="" className="w-full" />
          </div>
          <div className="flex">
            <div className="w-full space-y-6 flex flex-col items-center text-center">
              <h1 className="text-3xl">OUR GOAL</h1>
              <p>
                Inspired by the lives of historical women between the 17th and
                19th centuries, we create a portal into the communities they
                led, the items they held dearly, and the spaces they impacted.
                Our stories depict women from all the 10 provinces of Zambia in
                celebration and honour.
              </p>
              <button className="bg-white text-secondary px-10 py-4">
                READ MORE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
